import { useState } from "react";
import {useNavigate} from "react-router-dom";
import axios from "../../api/axiosInstance";
import Header from "../PublicHeader";
import Footer from "../Footer";
import { FaEnvelope, FaLock } from "react-icons/fa";
import { castIcon } from "../../utils/castIcon";

const EmailIcon = castIcon(FaEnvelope);
const PasswordIcon = castIcon(FaLock);

const Login = () => {
    const [error, setError] = useState("");

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();

    const handleLogin = async (event: React.FormEvent) => {
        event.preventDefault();
        setError("");

        try {
            const response = await axios.post<{
                access_token: string;
                restaurant_id: string;
                restaurant_name: string;
                slug: string;
            }>("/api/login", { email, password },
                { headers: { "X-Skip-Auth": "true" } });

            console.log("slug from backend:", response.data.slug);

            localStorage.setItem("access_token", response.data.access_token);
            localStorage.setItem("restaurant_id", response.data.restaurant_id);
            localStorage.setItem("restaurant_name", response.data.restaurant_name);
            localStorage.setItem("restaurant_slug", response.data.slug);

            navigate("/dashboard");
        } catch (err: any) {
            console.error("❌ Login error:", err);
            setError(err.response?.data?.error || "Login failed. Please try again.");
            return;
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 flex flex-col">
            <Header/>

            <main className="flex-1 flex items-center justify-center px-6 py-10">
                <div className="bg-white shadow-2xl rounded-xl p-8 w-full max-w-md animate-fade-in-up">
                    <h2 className="text-3xl font-extrabold text-center text-blue-700 mb-6">
                        🔒 Restaurant Login
                    </h2>

                    {error && (
                        <div className="bg-red-100 text-red-700 px-4 py-2 rounded text-sm mb-4 text-center">
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleLogin} className="space-y-5">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                            <div className="relative">
                                <EmailIcon className="text-gray-500 mr-2"/>
                                <input
                                    type="email"
                                    className="w-full pl-10 p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                                    placeholder="you@example.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
                            <div className="relative">
                                <PasswordIcon className="text-gray-500 mr-2"/>
                                <input
                                    type="password"
                                    className="w-full pl-10 p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                                    placeholder="••••••••"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>
                        </div>

                        <button
                            type="submit"
                            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg font-semibold transition duration-300"
                        >
                            🚀 Login
                        </button>
                    </form>

                    <p className="text-center text-sm text-gray-600 mt-3">
                        <a href="/forgot-password" className="text-blue-600 hover:underline font-medium">
                            Forgot your password?
                        </a>
                    </p>
                    <p className="text-center text-sm text-gray-600 mt-4">
                        New here?{" "}
                        <a href="/register" className="text-blue-600 hover:underline font-medium">
                            Create an account
                        </a>
                    </p>
                </div>
            </main>

            <Footer/>
        </div>
    );
};

export default Login;
